import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Fleet from "@/pages/Fleet";
import VehicleDetail from "@/pages/VehicleDetail";
import Placeholder from "@/pages/Placeholder";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/reservations" element={<Placeholder />} />
              <Route path="/fleet" element={<Fleet />} />
              <Route path="/fleet/:id" element={<VehicleDetail />} />
              <Route path="/customers" element={<Placeholder />} />
              <Route path="/contracts" element={<Placeholder />} />
              <Route path="/payments" element={<Placeholder />} />
              <Route path="/maintenance" element={<Placeholder />} />
              <Route path="/reports" element={<Placeholder />} />
              <Route path="/settings" element={<Placeholder />} />
            </Route>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
